import Big, { BigSource } from 'big.js'
import { big, denormalize, normalize } from 'src/common/utils/big-utils'

export const getDenormalizedAmount = (
  amount: BigSource,
  decimals?: number
): string => {
  if (decimals) {
    return denormalize(amount, decimals).toFixed(0)
  } else {
    return amount.toString()
  }
}

export const getNormalizedAmount = (
  amount: BigSource,
  decimals?: number
): Big => {
  if (decimals) {
    return normalize(amount, decimals)
  } else {
    return big(amount)
  }
}